import React from 'react';

const SharedTools = () => {

    return (
        <span className="SharedTools">
            <button className="btn btn-outline-dark sp-margin5 btn-reports-sm" title="File Download">
                <i className="bi bi-download" alt="file download icon"></i>
            </button>
            <button className="btn btn-outline-dark sp-margin5 btn-reports-sm" title="Refresh Page">
                <i className="bi bi-arrow-clockwise" alt="refresh page icon"></i>
            </button>
            <button className="btn btn-outline-dark sp-margin5 btn-reports-sm" title="Print page">
                <i className="bi bi-printer" alt="printer icon"></i>
            </button>
        </span>
    );
};

export default SharedTools;
